import { render, staticRenderFns } from "./InterestIndicatorsSection.vue?vue&type=template&id=527d8916&"
import script from "./InterestIndicatorsSection.vue?vue&type=script&lang=js&"
export * from "./InterestIndicatorsSection.vue?vue&type=script&lang=js&"
import style0 from "./InterestIndicatorsSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports